import { element as ngElement } from 'angular';
import { Directive, Inject, OnInit } from 'angular-ts-decorators';
import { isMobile } from 'src/Foundation/Design/platform';
import { getHeaderHeight, isHeaderTransparent } from 'src/Feature/Navigation/platform';

interface ICondensedMenuScope extends ng.IScope {
  condensedMenuContent: JQuery;
  condensedVisible: boolean;
  customizerVisible: boolean;
  menuToggleState: boolean;
  isOfferActive: boolean;
  isMobile: () => boolean;

  onMenuToggle(): void;
}

@Directive({
  restrict: 'E',
  selector: 'condensedMenu',
})
export class CondensedMenuDirective implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$scope', '$element', '$window'];

  constructor(
    @Inject('$scope') private $scope: ICondensedMenuScope,
    @Inject('$element') private $element: JQLite,
    @Inject('$window') private $window: ng.IWindowService
  ) {
    this.$scope.menuToggleState = false;
    this.$scope.isOfferActive = false;
    this.$scope.isMobile = isMobile;
    this.$scope.onMenuToggle = (): void => { this.$scope.menuToggleState = !this.$scope.menuToggleState; };
  }

  public ngOnInit(): void {
    const customizerElement: HTMLElement = document.getElementById('customizer');
    const footerElement: HTMLElement = document.getElementsByTagName('footer')[0];
    const content: JQuery = this.$element.find('.condensed-menu__content');

    let previousOffset = 0;
    const isInViewport = (element: HTMLElement): boolean => {
      const rect: ClientRect = element.getBoundingClientRect();
      const html: HTMLElement = document.documentElement;

      return rect.top > (window.innerHeight || html.clientHeight) || rect.bottom < 0;
    };

    this.$scope.condensedMenuContent = content;
    this.$scope.customizerVisible = false;

    ngElement(this.$window).on('load touchmove scroll', (event: JQuery.TriggeredEvent): void => {
      const scrollTop: number = this.$window.scrollY;
      const elementOffset = this.$element.offset().top + (isHeaderTransparent() ? getHeaderHeight() : 0);

      if (customizerElement) {
        this.$scope.customizerVisible = !isInViewport(customizerElement) || !isInViewport(footerElement);
      }

      if (!ngElement(event.target)[0] || scrollTop === previousOffset) {
        this.$scope.$apply();
        return;
      }

      previousOffset = scrollTop;

      this.$scope.condensedVisible = scrollTop > (elementOffset > 0 ? elementOffset : 0);
      this.$scope.$apply();
    });
  }
}
